import Weatherapp from './Compenents/WeatherApp/Wetherapp';
import './App.css';


function App() {
  return (
  <Weatherapp/>
  );
}

export default App;
